import { useEffect, useState, type FC } from 'react';

import { getZeroOption, type Option, getValidSelectValue } from '@/src/utils';
import { SimpleSingleSelect, FilterBarContainer } from '@/src/ui';
import { apiRequest } from '@/src/services';

interface FilterOptions {
    districtOptions: Option[];
}

interface SchoolFiltersProps {
    districtId: number;
    setDistrictId: (districtId: number) => void;
}

const SchoolFilters: FC<SchoolFiltersProps> = ({ districtId, setDistrictId }) => {
    const [districtOptions, setDistrictOptions] = useState<Option[]>([getZeroOption('Loading...')]);

    useEffect(() => {
        async function fetchDistricts() {
            try {
                const res = await apiRequest<FilterOptions>(
                    'GET',
                    'utility/filterData?getDistrict=true'
                );
                const data = res.data;
                const districts = data.districtOptions;
                const options: Option[] = [
                    getZeroOption('All'),
                    ...districts.map((d: any) => ({ id: d.id, name: d.name })),
                ];
                setDistrictOptions(options);
            } catch {
                setDistrictOptions([getZeroOption('All')]);
            }
        }
        fetchDistricts();
    }, []);

    return (
        <FilterBarContainer>
            <SimpleSingleSelect
                name="districtId"
                label="Filter by District"
                options={districtOptions}
                value={Number(
                    getValidSelectValue(districtId, districtOptions, districtOptions[0]?.id ?? 0)
                )}
                onChange={(e) => setDistrictId(Number(e.target.value))}
                sx={{ minWidth: 160, maxWidth: 220, mt: 0.5 }}
            />
        </FilterBarContainer>
    );
};

export default SchoolFilters;
